import React, { useEffect } from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { useHistory } from 'react-router-dom';

import { buyInfince, processCard } from '../../store/signup/signupAction';
import cardImages from '../../assets/images/credit_cards.png';

import './Payment.scss';

/**
 * Payment component
 * @param {*} param0
 */
const Payment = ({
    domainName,
    needDomain,
    domanPrice,
    icann,

    basicData,

    stripeError,
}) => {
    const history = new useHistory();

    useEffect(() => {
        if (!basicData) {
            history.push('/');
        }
    }, [basicData, history]);
    /**
     * Function to save new card to customer account in stripe.
     * @param {*} event
     */
    const handleSubmit = async (event) => {};
    return (
        <div className="content payment-page">
            <div className="content-block-right">
                <div className="sec-header-block">
                    <h1>Payment</h1>
                    <p>
                        Your credit card will be billed at the start of every
                        calendar month, for the previous month’s (prorated)
                        usage.
                    </p>
                    {needDomain && (
                        <p>
                            Your domain “<strong>{domainName}</strong>” for{' '}
                            <strong>${domanPrice}</strong>
                            <br />
                            (including ICANN fee of ${icann}) will be purchased
                            now using your credit card.
                        </p>
                    )}
                </div>

                <h3>Credit Card Details</h3>
                <div className="card-wrapper">
                    <img alt="credit cards" src={cardImages} />
                </div>
                <div className="form-group" style={{ marginBottom: '25px' }}>
                    <div
                        className="form-control"
                        style={{ paddingTop: '12px' }}
                    >
                        <CardElement
                            onBlur={handleSubmit}
                            options={{
                                hidePostalCode: true,

                                style: {
                                    base: {
                                        border: '1px solid black',
                                        fontSize: '16px',
                                        color: '#424770',
                                        '::placeholder': {
                                            color: '#aab7c4',
                                        },
                                    },
                                    invalid: {
                                        color: '#9e2146',
                                    },
                                    marginTop: '25px',
                                },
                            }}
                        />
                    </div>
                    {stripeError && (
                        <span className="input-error mb-0">{stripeError}</span>
                    )}
                </div>
                <p className="note">
                    * We are not saving credit card information in our server.
                    Information is encrypted and stored in high secure payment
                    gateway. For more details read{' '}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://stripe.com/us/privacy"
                        className="secondary"
                    >
                        payment gateway privacy policy.
                    </a>
                </p>
                <p className="note">
                    By clicking "Setup Infince" you agree to our
                    <a
                        href="https://www.infince.com/terms-and-conditions/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="secondary"
                    >
                        {' '}
                        Terms of Service
                    </a>{' '}
                    and{' '}
                    <a
                        className="secondary"
                        rel="noopener noreferrer"
                        href="https://www.infince.com/privacy-policy/"
                        target="_blank"
                    >
                        Privacy Policy.
                    </a>
                </p>
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    buyInfince,
    processCard,
};
const mapStateToProps = (store, props) => ({
    needDomain: get(store, 'signupReducer.needDomain', null),
    stateList: get(store, 'signupReducer.stateData.states', []),
    basicData: get(store, 'signupReducer.basicData', null),
    domainPageData: get(store, 'signupReducer.getDomain', null),
    domainName: get(store, 'signupReducer.needDomain')
        ? get(store, 'signupReducer.getDomain.domainDetails.domain', '')
        : get(store, 'signupReducer.domainDetails.businessDomain', ''),
    domainDetails: get(store, 'signupReducer.needDomain')
        ? get(store, 'signupReducer.getDomain', '')
        : get(store, 'signupReducer.domainDetails', ''),
    domanPrice: get(store, 'signupReducer.getDomain.domainDetails.price'),
    icann: get(store, 'signupReducer.getDomain.domainDetails.icann_fee'),
    planDetails: get(store, 'signupReducer.planDetails'),
    businessMail: get(store, 'signupReducer.businessMail'),
    stripeError: get(store, 'signupReducer.stripeErrorMsg'),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
